import { Table } from './table'

export { Table }
